// ============================================================
// Shared constants
// ============================================================
export const COOKIE_NAME = "cardbuzz_session";
export const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;
export const SESSION_TTL_SECONDS = 365 * 24 * 60 * 60;

// IOPass endpoints
export const IOPASS_API_BASE = "https://api.iopass.net";
export const IOPASS_AUTHORIZE_URL = "https://api.iopass.net/oauth/authorize";
export const IOPASS_TOKEN_URL = `${IOPASS_API_BASE}/oauth/token`;
export const IOPASS_USERINFO_URL = `${IOPASS_API_BASE}/oauth/userinfo`;

// ============================================================
// Shared types
// ============================================================
export type UserRole = "admin" | "user" | "secretary";

export interface SessionPayload {
  sub: string;       // IOPass sub (user ID)
  role: UserRole;
  name: string;
  email: string;
  exp: number;       // expiry timestamp
}

export interface CardData {
  uid: number;
  personalId: string;
  authEmail: string | null;
  status: string;
  nameEn: string | null;
  nameZhCht: string | null;
  nameZhChs: string | null;
  titleEn: string | null;
  titleZhCht: string | null;
  titleZhChs: string | null;
  companyEn: string | null;
  companyZhCht: string | null;
  companyZhChs: string | null;
  bioEn: string | null;
  bioZhCht: string | null;
  bioZhChs: string | null;
  phone: string | null;
  email: string | null;
  website: string | null;
  address: string | null;
  profileImage: string | null;
  coverImage: string | null;
  qrCode: string | null;
  pwaHash: string | null;
  theme: string | null;
  customCss: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

// Calendar types
export type CalendarProvider = "google" | "microsoft" | "lark" | "icloud";

export interface CalendarAccount {
  id: number;
  workspaceId: number;
  userId: number;
  provider: CalendarProvider;
  accountEmail: string;
  accessToken: string | null;
  refreshToken: string | null;
  tokenExpiry: number | null;
  syncEnabled: boolean;
  lastSyncAt: string | null;
}

export type VisibilityLevel = "full" | "busy" | "hidden";

export interface VisibilityPolicy {
  provider: CalendarProvider;
  level: VisibilityLevel;
}

// i18n
export type Locale = "en" | "zh-chs" | "zh-cht";
export const DEFAULT_LOCALE: Locale = "en";
export const SUPPORTED_LOCALES: Locale[] = ["en", "zh-chs", "zh-cht"];
